import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, TileLayer, ZoomControl } from "react-leaflet";
import GrainMill from "../../assets/images/grain-mill.svg?no-inline";
import House from "../../assets/images/house.svg?no-inline";
import Oven from "../../assets/images/oven.svg?no-inline";
import SacralBuilding from "../../assets/images/sacral-building.svg?no-inline";
import { PlaceType } from "../home/Map";
import styles from "./Map.module.scss";

interface MapProps {
  latitude: number | null;
  longitude: number | null;
  markerType?: PlaceType;
}

const Map = ({
  latitude,
  longitude,
  markerType = PlaceType.House,
}: MapProps) => {
  const houseIcon = new Icon({
    iconSize: [25, 25],
    iconUrl: House,
  });

  const grainMillIcon = new Icon({
    iconSize: [27, 22],
    iconUrl: GrainMill,
  });

  const ovenIcon = new Icon({
    iconSize: [31, 38],
    iconUrl: Oven,
  });

  const sacralBuildingIcon = new Icon({
    iconSize: [19, 31],
    iconUrl: SacralBuilding,
  });

  const getCategoryIcon = () => {
    if (markerType === PlaceType.GrainMill) {
      return grainMillIcon;
    } else if (markerType === PlaceType.SacralBuilding) {
      return sacralBuildingIcon;
    } else if (markerType === PlaceType.Oven) {
      return ovenIcon;
    }
    return houseIcon;
  };

  if (!latitude || !longitude) {
    return null;
  }

  return (
    <MapContainer
      zoom={14}
      zoomControl={false}
      className={styles.map}
      scrollWheelZoom={false}
      attributionControl={false}
      center={[latitude, longitude]}
    >
      <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
      <Marker position={[latitude, longitude]} icon={getCategoryIcon()} />
      <ZoomControl position="bottomright" />
    </MapContainer>
  );
};

export default Map;
